import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "list", "topButton", "bottomButton"]

  connect() {
    this.mutationObserver = new MutationObserver((mutations) => this.handleMutations(mutations))

    if (this.hasListTarget) {
      this.mutationObserver.observe(this.listTarget, { childList: true })
    }

    requestAnimationFrame(() => {
      this.scrollToBottom(false)
      this.updateButtons()
    })
  }

  disconnect() {
    this.mutationObserver?.disconnect()
  }

  scrollToTop() {
    this.containerTarget.scrollTo({ top: 0, behavior: "smooth" })
  }

  scrollToBottom(smooth = true) {
    this.containerTarget.scrollTo({
      top: this.containerTarget.scrollHeight,
      behavior: smooth ? "smooth" : "auto"
    })
  }

  updateButtons() {
    const scrollTop = this.containerTarget.scrollTop
    const distanceFromBottom = this.containerTarget.scrollHeight - this.containerTarget.clientHeight - scrollTop
    const nearTop = scrollTop <= 12
    const nearBottom = distanceFromBottom <= 12

    this.topButtonTarget.classList.toggle("hidden", nearTop)
    this.bottomButtonTarget.classList.toggle("hidden", nearBottom)
  }

  handleMutations(mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return
        if (node.dataset.messageRole !== "assistant") return

        node.animate(
          [
            { opacity: 0, transform: "translateY(20px)" },
            { opacity: 1, transform: "translateY(0)" }
          ],
          {
            duration: 320,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            fill: "both"
          }
        )
      })
    })

    this.updateButtons()
  }
}
